import React, { useEffect } from "react";

import { useRoute, useIsFocused } from "@react-navigation/native";
import {
  _goToAddNoteForMySelf,
  _goToBack,
  _goToEditCustomerNote,
  _goToNote,
} from "routers/helper";
import { RootRouteProps } from "routers/types/stack";

import { View } from "react-native";

import css from "styles";

import {
  Icon,
  Text,
  Empty,
  Error,
  Header,
  Button,
  Loading,
  Separator,
  AddButtonFloat,
  AnimatedInfinityList,
} from "components";

import { useNotes } from "clients/apis";
import { sizes, colors, strings } from "assets/constants";

export default function CustomerNotes() {
  const customer = useRoute<RootRouteProps<"customer_notes">>().params;
  const isFocused = useIsFocused();

  const {
    data,
    error,
    isError,
    refetch,
    isLoading,
    isRefetching,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useNotes({
    customerId: customer?.name === strings.myself ? null : customer.id,
    mySelf: customer?.name === strings.myself ? 1 : 0,
  });

  useEffect(() => {
    isFocused && refetch();
  }, [isFocused, refetch]);

  const _goToEdit = (note: NoteT) => _goToEditCustomerNote({ data: note });
  const _onAddNote = () =>
    customer?.name === strings.myself
      ? _goToAddNoteForMySelf()
      : _goToNote({ customer, data: null });

  const _renderItem = (items: []) => {
    return items.map((note: NoteT, key: number) => (
      <View key={String(key)}>
        {key !== 0 && <Separator weight={3} color={colors.white} />}
        <View style={{ padding: sizes.space }}>
          <View
            style={{
              ...css.rowCenterAlign,
              ...css.selfEnd,
            }}
          >
            <Button
              onPress={() => _goToEdit(note)}
              width={100}
              height={40}
              contentSeparator={5}
              bgColor={colors.transparent}
              title={{ value: "ویرایش", color: colors.info }}
              icon={{ name: "edit-2", size: 12, color: colors.info }}
            />
            <View
              style={{
                ...css.rowCenterAlign,
                width: 150,
                justifyContent: "flex-end",
              }}
            >
              <Text>
                {" "}
                {note?.create_time} - {note?.create_date}{" "}
              </Text>
              <Icon size={15} color={colors.theme} name="calendar" />
            </View>
          </View>
          <Text weight="bold">{note?.title}</Text>
          <Text style={{ lineHeight: 22 }}>{note?.description}</Text>
        </View>
      </View>
    ));
  };

  const _renderContent = () => {
    if (isLoading) {
      return <Loading style={{ marginTop: 20 }} />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    if (data?.pages?.[0]?.data?.data?.length === 0) {
      return <Empty style={{ marginTop: 20 }} message={strings.no_note} />;
    }

    return (
      <AnimatedInfinityList
        responseData={data}
        onRefresh={refetch}
        renderItemList={_renderItem}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        paddingTop={sizes.space}
        paddingBottom={70}
      />
    );
  };

  return (
    <>
      <Header title={strings.notes_on + " " + customer.name} />
      {_renderContent()}
      <AddButtonFloat onPress={_onAddNote} />
    </>
  );
}
